import { render, staticRenderFns } from "./CertificateWarningCard.vue?vue&type=template&id=a4de50d6&scoped=true&"
import script from "./CertificateWarningCard.vue?vue&type=script&lang=js&"
export * from "./CertificateWarningCard.vue?vue&type=script&lang=js&"
import style0 from "./CertificateWarningCard.vue?vue&type=style&index=0&id=a4de50d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4de50d6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VRow})
